import { ActivatableTransportType } from './activatable-transport-type.enum';
export class ActivatableTransportQuery {

  query: string;

  type: ActivatableTransportType;
}
